export default {
  getExtension(name) {
    if(name) {
      var regexp = /(?:\.([^.]+))?$/;
      return regexp.exec(name)[1];
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/api/helpers/file.js